<div class="background-wrapper"></div>

<div *ngIf="showMainPage" class="card">

  <h3>Application Details N2P</h3>

  <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group row">
      <div class="form-group col-md-12">
      <label class="lable-css radio-inline" for="FJL required">Type of Work:
      </label>
      <input class="radio-inline" formControlName="workType" (change)="radioSelect()" type="radio" id="option1"
        value="LFN" />
      <label class="lable-css radio-inline" for="LFN">LFN </label>
      <input class="radio-inline" formControlName="workType" (change)="radioSelect()" type="radio" id="option2"
        value="DFN" />
      <label class="lable-css radio-inline" for="DFN">DFN</label>
      </div>
      
    </div>
    <div class="form-group row">
      <div class="form-group col-md-6">
        <label class="lable-css">UFA Category:</label>
        <select formControlName="ufaCategory" id="ufaCategory" class="form-control">
          <option value="" selected>Select</option>
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label for="ada" class="lable-css">FCA ID:</label>
        <input type="text" id="ada" formControlName="adaId" name="ada" placeholder="Enter ADA ID" required />
      </div>
    </div>
    <div class="form-group row">
      <div class="form-group col-md-6">
        <label class="lable-css">Program:</label>
        <select formControlName="type_program" id="type_program" class="form-control">
          <option value="" selected>Select</option>
          <option value="n2p">N2P</option>
          <option value="rrac">RRAC</option>
        </select>
      </div>
   
    </div>
    <div class="form-group row">
      <div class="form-group col-md-6">
        <app-upload-file [flowName]="flowName" (uploaded)="fileUploaded($event)"></app-upload-file>
        <br />
        <p>Sample Location File :  <span (click)="downloadFile()">ADA_Location.xlsx  (3BMT-05-53_Location.xlsx)</span></p>
      </div>      
    </div>
    @if (showLFNSubmit) {
    
    <button type="button" (click)="callSheetValidate()">Sheet-Validation</button>
    <!-- <a href="/download-error-report" download>Download Error Report</a>
    <script>
      // auto-click to trigger download immediately
      document.querySelector('a').click();
    </script> -->
    <button type="submit" [class]="myForm.invalid ? 'gray-button' : ''" [disabled]="myForm.invalid">
      Submit
    </button>
    }
  </form>
  
</div>
<!-- DFN Component Called-->
<div *ngIf="showDFNCard" >
    <app-dfn-djl-flow 
      [inputData]="myForm"
      (disableMainForm)="disableMainForm()"
      [showDFLFieldsDFN]="showDFLFieldsDFN"
      [file]="file"
    ></app-dfn-djl-flow>
  </div>

<div *ngIf="smp_connectivity_flag">
  <app-smp-connectivity-n2p
    [inputData] = "tableData"
  ></app-smp-connectivity-n2p>
</div>


<div *ngIf="bjl_flag">
  <app-select-bjl-n2p
    [inputData]="tableData"
  ></app-select-bjl-n2p>
</div>

<div *ngIf="bjl_structure_flag">
  <!-- <app-select-smp-n2p
     [inputData] = "tableData"
  >
  </app-select-smp-n2p> -->
            <!-- <app-map-n2p              
                [inputData]="tableData"
                (OnSelectProceedMap) = "OnSelectProceedMap($event)"
            ></app-map-n2p>

            <app-table                 
                table_title="selectBjl" 
                [inputData]="tableData"
                (appItemEvent)="receiveTableEventStructure($event)" >
            </app-table> -->
<app-n2p-upstream-equipment
    [inputData]="tableData"
></app-n2p-upstream-equipment>
</div>

<div *ngIf="final_screen">
  <app-final-page-n2p
    [inputData]="tableData"
  ></app-final-page-n2p>
</div>

<!-- spinner Component Called-->
<div *ngIf="isLoading">
  <ngx-spinner type = "ball-scale-multiple"></ngx-spinner> 
</div>